export default __webpack_public_path__ + "static/logo-e0b8d7868c39610e201a9f2460548d5b.png";